export const translation = {
  hotel: {
    'Distance to lift': 'Avstånd till lift',
    'Distance to town centre': 'Avstånd till centrum',
    'Distance to skibus': 'Avstånd till skidbuss',
    'Customer rating': 'Kundbetyg',
    'Book now': 'Boka nu',
    'Show photos': 'Visa bilder',
    'Rooms at ': 'Rum på ',
    'Guest reviews': 'Gästrecensioner',
    'Guest review description':
      'Våra citat hämtas från enkäter som fylls i av våra resenärer efter avslutad resa. Vi är stolta över att många av våra gäster återkommer år efter år. Efter senaste vintersäsongen(2024) svarade över 93% av gästerna att de vill resa med oss igen.',
    'Hotel facilities': 'Hotellfaciliteter',
    Yes: 'Ja',
    'Show all': 'Visa alla',
    'Show less': 'Visa färre',
    'Tripadvisor title': 'Toppbetyg på Tripadvisor',
    'Tripadvisor description':
      '{{rating}} av 5 stjärnor baserat på {{numberOfRatings}} omdömen',
    'Tripadvisor link': 'Läs mer på Tripadvisor',
    AUT: 'Österrike',
    ITA: 'Italien',
    FRA: 'Frankrike',
    'Title template': 'Boka {{hotel}} i {{destination}}, {{country}}',
  },
  booking: {
    StartingPrice: 'Boka från {{price}} kr',
    PerPersonPrice: 'Boka från {{price}} kr/person',
    PerPersonPriceCurrency: '{{price}} kr/person',
    FamilyPrice: 'Familjepris från {{price}} kr',
    TotalPrice: 'Totalpris från {{price}} kr',
    FlightPrice: 'Endast flyg från {{price}} kr',
    Currency: 'kr',
    Savings: 'Spara {{price}} kr',
    'All destinations': 'Alla destinationer',
    'Could not find any proposals':
      'Tyvärr hittade vi inga lediga resor {{date}}.',
    'No proposals found':
      'Inga förslag hittades. Prova att ändra filtrering eller sök på annat datum.',
    'Show period': 'Visa resor {{date}}',
    PackagePrice: 'Boka Alp Inclusive från {{price}} kr/person',
    'Book now': 'Boka nu',
    'Send request': 'Skicka förfrågan',
    'Coming soon': 'Kommer snart!',
    Traveltype: 'Resetyp',
    From: 'Från',
    To: 'Till',
    Traveldate: 'Datum',
    Travelers: 'Resenärer',
    Search: 'Sök resa',
    'Book trip': 'Boka resa',
    'Week short': 'v.',

    Room: 'Rum',
    Rooms: 'Rum',

    room: 'rum',
    rooms: 'rum',

    adult: 'Vuxen',
    Adults: 'Vuxna',
    adults: 'vuxna',
    'No adults': 'Inga vuxna',
    'Children Ages': 'Barn/ung. (0-17 år):',
    Child: 'Barn',
    child: 'barn',
    Children: 'Barn',
    children: 'barn',
    'No children': 'Inga barn',
    'Age children': 'Ålder barn/ungdom (vid hemresa):',

    'Child nr': 'Barn {{nr}}',
    'Rooms and travelers': 'Rum och resenärer',
    years: 'år',
    MonthShort: {
      1: 'jan',
      2: 'feb',
      3: 'mar',
      4: 'apr',
      5: 'maj',
      6: 'jun',
      7: 'jul',
      8: 'aug',
      9: 'sep',
      10: 'okt',
      11: 'nov',
      12: 'dec',
    },
    Charter: 'Paketresa',
    Hotel: 'Endast hotell',
    Flight: 'Endast flyg',
    'Find trip': 'Sök resa',
    'Add room': 'Lägg till rum',
    'Remove room': 'Ta bort rum',
    charterTypes: {
      Winter: 'Skidresor',
      Summer: 'Sommarresor',
      Christmas: 'Julbordsresor',
      Hiking: 'Vandringsresor',
    },
    priceReference:
      'Avser resa från {{airport}} {{travelDateFrom}} på {{hotelName}}  i {{roomDescription}}',
    priceReferenceWithoutHotel:
      'Avser resa från {{airport}} {{travelDateFrom}} i {{roomDescription}}',
    'Find price and book': 'Se pris & boka',
    Close: 'Stäng',
    'Book before': 'Boka senast',
    'More than 9 travelers?': 'Fler än 9 resenärer? Klicka här',
  },
  footer: {
    'Select country': 'Välj land',
    'Follow us on Social Media': 'Följ oss på sociala medier',
    Winter: 'Vinter',
    Summer: 'Sommar- och vandringsresor',
    Conference: 'Konferens',
    News: 'Nyhet!',
    'E-mail address': 'Din e-postadress',
    Subscribe: 'Prenumerera',
  },

  header: {
    'Open hours today': 'Öppet idag kl',
    Menu: 'Meny',
    Start: 'Start',
  },
  image: {
    'Zoom in': 'Zooma in',
  },

  labels: {
    'city-center': 'Centrum',
    'city-centre-value': '{{value}} m',
    'ski-bus': 'Skidbuss',
    'ski-bus-value': '{{value}} m',
    'ski-lift': 'Lift',
    'ski-lift-value': '{{value}} m',
    'black-runs': 'Svarta pister',
    'black-runs-value': '{{value}} st',
    'red-runs': 'Röda pister',
    'red-runs-value': '{{value}} st',
    'blue-runs': 'Blå pister',
    'blue-runs-value': '{{value}} st',
    peak: 'Högsta åkhöjd',
    'peak-value': '{{value}} m',
    valley: 'Byns höjd',
    'valley-value': '{{value}} m',
    vertical: 'Fallhöjd',
    'vertical-value': '{{value}} m',
    'piste-length': 'Total pistlängd',
    'piste-length-value': '{{value}} km',
    'ski-lifts': 'Antal liftar',
    'ski-lifts-value': '{{value}} st',
    'transfer-time': 'Transfertid',
    'transfer-time-value': '{{value}}',
    'cross-country-trails': 'Längdspår',
    'cross-country-trails-value': '{{value}} km',
    restaurants: 'Restauranger',
    'restaurants-value': '{{value}}',
    'mountain-restaurants': 'Bergsrestauranger',
    'mountain-restaurants-value': '{{value}}',
    'after-ski-bars': 'Afterski-ställen',
    'after-ski-bars-value': '{{value}}',
    bars: 'Barer',
    'bars-value': '{{value}}',
    monday: 'Måndag',
    tuesday: 'Tisdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lördag',
    sunday: 'Söndag',
    closed: 'Stängt',
  },
  error: {
    'Page not found': 'Sidan kunde inte hittas',
    'Page not found description':
      'Testa att hitta sidan i menyn ovan eller skriv in länken igen.',
  },
  charts: {
    variable: 'Jämför',
    destination: 'Destination',
    avg_snowfall: 'Snöfall',
    snowfall_days: 'Snödagar',
    avg_snow_depth: 'Snödjup',
    biggest_snowfall: 'Största snöfall',
    all: 'Alla destinationer',
    December: 'December',
    Januari: 'Januari',
    Februari: 'Februari',
    Mars: 'Mars',
    April: 'April',
  },
  countdown: {
    DAYS: 'Dagar',
    HOURS: 'Timmar',
    MINUTES: 'Minuter',
    SECONDS: 'Sekunder',
  },
  profile: {
    hero: {
      greeting: 'Hej {0}',
      header: 'Min resa',
      message: 'Hej {0}, välkommen till din resa',
      afterTripMessage: 'Tack för att du rest med oss {0}. Välkommen åter!',
      daysLeft: 'dagar kvar till avresa',
      title: 'Du reser till {0}',
    },
    navigation: {
      skiing: 'Skidåkning',
      hiking: 'Vandring',
      location: 'Orten',
    },
    flight: {
      header: 'Reseinformation',
      travelTime: 'Restid',
      addSki: 'Lägg till skidfrakt',
      luggage: '{0} incheckad väska per person max {1} ingår',
      skiLuggage: '1 par skidor + stavar, 1 par pjäxor, 1 hjälm - max {0}',
    },
    summary: {
      header: 'Sammanfattning',
      header2: 'Betalning',
      isPaid: 'Din resa är betald',
      isCancelled: 'Din resa är avbokad',
      bookingNumber: 'Bokningsnummer',
      bookingDate: 'Bokningsdatum',
      bookingPerson: 'Bokad av',
      bookingPrice: 'Totalpris',
      bookingFee: 'Anmälningsavgift',
      bookingFeeHelp: 'Betalas senast {0}',
      bookingPayment: 'Slutbetalning',
      bookingPaymentHelp: 'Betalas senast {0}',
      hint1: 'När resan är fullbetald kan du ladda ner din biljett här',
      hint2:
        'I nästa steg väljer du om anmälningsavgiften eller hela resans pris skall betalas',
      email: 'E-post',
      phoneNumber: 'Telefon',
      paid: 'Betalt hittills',
      leftToPay: 'Kvar att betala',
    },
    tabs: {
      booking: 'Bokning',
      faq: 'FAQ',
      addons: 'Tillval',
    },
    travellers: {
      header: 'Resenärer',
      name: 'Namn',
      room: 'Rum',
      type: 'Typ',
      typeAdult: 'Vuxen',
      typeChild: 'Barn',
      dateOfBirth: 'Född',
      gender: 'Kön',
      genderMale: 'Man',
      genderFemale: 'Kvinna',
      notice:
        'Vill du lägga till fler resenärer? Kontakta oss på info@alpresor.se eller <span>0771-20 20 20</span>',
    },
    destination: {
      header: 'Resmål och hotell',
      destination: 'Resmål',
      hotel: 'Hotell',
      checkIn: 'Check in',
      checkOut: 'Check out',
      package: 'Paket',
      linkLabel: 'Rum och resenärer',
      linkText: 'Se längre ner',
    },
    includes: {
      header: 'Mina tillval',
      seeAll: 'Se fler tillval',
      edit: 'Ändra',
      included: 'Ingår',
      skiSchool: 'Skidskola',
      excursion: 'Utflykt',
      skiRental: 'Skidhyra',
      skiPass: 'Liftkort',
      flightMeal: 'Flygmat',
      skiLuggage: 'Skidfrakt',
      transfer: 'Transfer',
      travelInsurance: 'Semesterförsäkring',
      hiking: 'Vandring',
      travelers: '{0} st',
      pricing: 'á {0}',
    },
    addons: {
      deadline: 'Boka senast {0}',
      order: 'Lägg till',
      durationDays: '{0} dagar',
      durationDay: '{0} dag',
      addonSkiCategory: 'Skidor',
      addonFlightCategory: 'Flyg',
      addonHikingCategory: 'Vandring',
      addonExcursionCategory: 'Andra aktiviteter',
      addonNoneCategory: 'Övrigt',
    },
    cta: {
      depositLeftText: 'Säkra din resa - betala {{amount}} kr nu',
      notPayedText: 'Slutbetala din resa',
      allPayedText: 'Din resa är betald',
      logout: 'Logga ut',
    },
    activities: {
      heading: 'Veckans aktiviteter',
      description:
        'Vi på STS Alpresor arrangerar massvis med utflykter och arrangemang i sällskap av våra guider och andra gäster för er att ta del av under resan.',
    },
    bookingConfirmation: {
      isPaid: 'Ladda ner biljett',
      notPaid: 'Ladda ner bokningsbekräftelse',
    },
    login: {
      form: {
        bookingRefLabel: 'Bokningsnummer',
        bookingRefPlaceholder: '00000000',
        emailLabel: 'E-mail',
        emailPlaceholder: 'du@exempel.se',
        submitLabel: 'Login',
        errorMessage: 'Något gick fel, se över dina uppgifter och försök igen',
      },
    },
  },
};
